import {ClickFormik} from "../../formik/clickabilityTabFormik";
import {ClickUnit} from "../../../../requests_cm/gecoContractsService/types";

export function onCreateClickHelper(newClick: ClickFormik, createClick: any, contractPeriodId: number) {
    const formattedClick = {
        ...newClick,
        click_period_id: newClick.click_period_id
            ? Number(newClick.click_period_id)
            : undefined,
        volume: Number(
            newClick.click_unit === ClickUnit.PERCENTAGE
                ? newClick.volumePct
                : newClick.volume
        ),
    };

    delete formattedClick.volumePct;

    createClick({
        ...formattedClick,
        contract_period_id: contractPeriodId,
    });
    return {...formattedClick, contract_period_id: contractPeriodId};
}